import store from '@/store';

export default {
    setCurrentLink(meta) {
        let nav = '';

        switch (meta) {
            case 'home':
                nav = 'home';
                break;
            case 'claim':
                nav = 'claim';
                break;
            case 'cover':
                nav = 'cover';
                break;
            case 'reports':
                nav = 'reports';
                break;
            case 'admin':
                nav = 'admin';
                break;
            case 'company':
                nav = 'company';
                break;
            case 'association':
                nav = 'association';
                break;
            case 'user':
                nav = 'user';
                break;
        }

        store.dispatch('navigation/updateCurrentLink', nav);
    },
};
